import React from "react";

interface ErrorCatchingProps {
	message: string;
}

/**
 * ErrorCatching
 * A reusable component to display error messages in a centered layout.
 * @param {string} message - The error message to display.
 * @returns {JSX.Element} - The rendered error component.
 */
const ErrorCatching: React.FC<ErrorCatchingProps> = ({ message }) => {
	return (
		<div className="flex items-center justify-center h-screen">
			<p className="text-lg font-semibold text-center text-red-600">
				{message}
			</p>
		</div>
	);
};

export default ErrorCatching;
